const PUBLIC_ROUTERS = {
  VENDORS_ONBOARDING_V1_STEP_0_WELCOME: `/vendors/onboarding/v1/step-0-welcome`,
  VENDORS_ONBOARDING_V1_STEP_1_BUSINESS_INFO: `/vendors/onboarding/v1/step-1-business-info`,
  VENDORS_ONBOARDING_V1_STEP_2_LEGAL_COMPLIANCE: `/vendors/onboarding/v1/step-2-legal-compliance`,
  VENDORS_ONBOARDING_V1_STEP_3_SERVICE_TERM: `/vendors/onboarding/v1/step-3-service-term`,
  VENDORS_ONBOARDING_V1_STEP_4_ADD_TECHNICIAN: `/vendors/onboarding/v1/step-4-add-technician`,
  VENDORS_ONBOARDING_V1_STEP_5_REVIEW_INFORMATION: `/vendors/onboarding/v1/step-5-review-information`,
  VENDORS_ONBOARDING_V1_STEP_FINAL_SUBMIT: `/vendors/onboarding/v1/step-final-submit`,
  /** Public (unauthenticated-style) order view; pathname prefix is `…/public`. */
  PUBLIC_ORDERS_DETAIL: `/public/orders/$orderId`,
};

export const MEMBER_JOIN_ROUTERS = {
  // Public routes
  INVITE: `/invite/$token`,
  INVITE_SIGN_UP: `/invite/$token/sign-up`,
  INVITE_VERIFY: `/invite/$token/verify`,
  INVITE_SUCCESS: `/invite/$token/success`,
  JOIN_STEP_SIGN_UP: `/join/sign-up`,
  JOIN_STEP_VERIFY_CODE: `/join/verify`,
  // Protected routes
  MY_PLACES: `/my/places`,
  MY_PLACES_ADD: `/my/places/add`,
  MY_PLACES_EXIST: `/my/places/exist`,
  MY_CHECKOUT: `/my/checkout`,
  MY_CHECKOUT_SUCCESS: `/my/checkout/success`,
  MY_VERIFY_PHONE: `/my/verify-phone`,
  MY_DOWNLOAD_APP: `/my/download-app`,
  /** Presale funnel entry — a public page that redirects to step 1, the way `/join` does. */
  PRESALE: `/presale`,
  /** Step 1 of the presale funnel — create the account. */
  PRESALE_SIGN_UP: `/presale/sign-up`,
  /** Step 1b — the emailed code that completes the account. */
  PRESALE_VERIFY: `/presale/verify`,
  /** Step 2 — add the home being reserved; its zipcode is the campaign gate. */
  PRESALE_PLACE: `/presale/place`,
  /** Step 3 — confirm the founding offer and reserve the spot. */
  PRESALE_CHECKOUT: `/presale/checkout`,
  /** Step 4 — the founding-member confirmation, where a successful charge lands. */
  PRESALE_SUCCESS: `/presale/success`,
  // migrated from owner app
  MY_HOME: `/my/home`,
  MY_CAMPAIGNS_DETAIL: `/my/campaigns/$campaignSlug`,
  MY_SETTINGS_ACCOUNT_PROFILE: `/my/settings/account/profile`,
  MY_SETTINGS_ACCOUNT_SECURITY: `/my/settings/account/security`,
  MY_SETTINGS_ACCOUNT_NOTIFICATIONS: `/my/settings/account/notifications`,
  MY_SETTINGS_ACCOUNT_INVOICES: `/my/settings/account/invoices`,
  MY_SETTINGS_ACCOUNT_BILLING: `/my/settings/account/billing`,
  MY_SETTINGS_ACCOUNT_BILLING_PAYMENTS: `/my/settings/account/billing/payments`,
  MY_SETTINGS_ACCOUNT_BILLING_WALLET: `/my/settings/account/billing/wallet`,
  MY_SETTINGS_HOUSEHOLD_MEMBERSHIP: `/my/settings/household/membership`,
  MY_SETTINGS_HOUSEHOLD_MEMBERS: `/my/settings/household/members`,
  MY_DOWNLOAD: `/my/download`,
  MY_FEEDBACK: `/my/feedback`,
  MY_FEEDBACK_DETAIL: `/my/feedback/$feedbackId`,
  MY_HELP: `/my/help`,
  MY_CHATS: `/my/chats`,
  /** The member's chat with Birdie (the customer agent), behind `rollout_customer_agent`. */
  MY_BIRDIE: `/my/birdie`,
  /** Mask for the order search palette (`?action=global-search`); the route itself redirects to Home. */
  MY_GLOBAL_SEARCH: `/my/global-search`,
  MY_LIST: `/my/list`,
  MY_LIST_ARCHIVED: `/my/list/archived`,
  MY_CART: `/my/cart`,
  MY_REQUESTS: `/my/requests`,
  MY_REQUESTS_SUBMIT: `/my/requests/submit`,
  MY_RECORDS: `/my/records`,
  MY_ORDERS: `/my/orders/$orderId`,
  MY_QUOTES: `/my/quotes`,
  MY_QUOTES_DETAIL: `/my/quotes/$quoteId`,
  MY_ORDERS_CREATE: `/my/orders/create`,
  MY_SETTINGS: `/my/settings`,
  MY_ONBOARDING: `/my/onboarding`,
} as const;

export const ERROR_ROUTERS = {
  ERROR_404: `/page-not-found`,
  ERROR_403: `/page-forbidden`,
} as const;

export const APP_ROUTERS = {
  ...PUBLIC_ROUTERS,
  ...MEMBER_JOIN_ROUTERS,
  ...ERROR_ROUTERS,
};
